
    import { ClubPackage, ClubPackageFeature, Currency, MarketFeature } from '@/models';
    import { currencyHTML } from '@/utils/filters/currency';
    import ClubFeatureCostText from '@/components/club/club-feature-cost-text.vue';
    import Vue, { PropType } from 'vue';

    export default Vue.extend({
        name: "ClubPricingMatrixItem",
        components: {
            'club-feature-cost-text': ClubFeatureCostText,
        },
        props: {
            selectedPackage: {
                type: Object as PropType<ClubPackage>,
                required: true,
            },
            allMarketFeatures: {
                type: Array as PropType<MarketFeature[]>,
            },
            memberMatchaMarketFeature: {
                type: Object as PropType<MarketFeature>
            },
            courtBookingMarketFeature: {
                type: Object as PropType<MarketFeature>
            },
            courtBookingLumpOnlyFee: {
                type: String
            },
            courtBookingLumpOnlyCurrency: {
                type: Object as PropType<Currency>
            },
            billingCycle: {
                type: Object
            }
        },
        methods: {
            getPackageFeatures(currentPackage: ClubPackage): MarketFeature[] {
                const includedFeatures = [] as MarketFeature[];

                currentPackage.feature_set.forEach((clubPackageFeature: ClubPackageFeature) => {
                    const fullMarketFeature = this.allMarketFeatures.find(f => f.feature == Number(clubPackageFeature.id));
    
                    if(fullMarketFeature)
                        includedFeatures.push(fullMarketFeature);
                });

                return includedFeatures;
            },
            featureClass(currentPackage: ClubPackage, featureName: string): string {
                const currentFeature = currentPackage.feature_set.find(f => f.name == featureName);
                if(!currentFeature)
                    return "not-available";

                return "";
            },
            featureStatusImage(currentPackage: ClubPackage, featureName: string): string {
                const currentFeature = currentPackage.feature_set.find(f => f.name == featureName);
                if(currentFeature)
                    return require("@/assets/images/feature-available.svg");
                else
                    return require("@/assets/images/feature-not-available.svg");
            },
            getPriceHTML(amount: string, currencyObj: Currency, postfix: string): string {
    
                if(!(amount && currencyObj))
                    return "";
    
                const postfixHTML = postfix ? `<span class='postfix'>${postfix}</span>` : "";

                return `${currencyHTML(amount, currencyObj, true, false)}${postfixHTML}<span class="frequency">&nbsp;/ ${this.billingCycle.frequency}</span>`;
            }
        }

    })
